import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  showPrivacyPolicy = false;
  showTerms = false;

  quickLinks = [
    { label: 'Home', path: '/home' },
    { label: 'Products', path: '/products' },
    { label: 'About Us', path: '/about' },
    { label: 'Contact', path: '/contact' }
  ];

  productCategories = [
    
    'Canvas Tote Bags',
    'Bags',
    'Custom Bags',
  ];

  socialLinks = [
  { name: 'Facebook', icon: 'fab fa-facebook-f', url: 'https://facebook.com/aadinathenterprises' },
  { name: 'Instagram', icon: 'fab fa-instagram', url: 'https://instagram.com/aadinathenterprises' },
  { name: 'LinkedIn', icon: 'fab fa-linkedin-in', url: 'https://linkedin.com/company/aadinathenterprises' },
  { name: 'WhatsApp', icon: 'fab fa-whatsapp', url: 'https://wa.me/919768301159' }
];

  // WhatsApp Quote Functionality
  requestWhatsAppQuote(): void {
    const message = `Hello Aadinath Enterprises!

I found your website and I'm interested in your products and services. Could you please help me with:

1. Product information and pricing
2. Customization options available
3. Minimum order quantities
4. Delivery timelines
5. Export services

Looking forward to hearing from you!

Best regards`;

    const whatsappUrl = `https://wa.me/919768301159?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  }

  openSocialLink(url: string): void {
    if (url !== '#') {
      window.open(url, '_blank');
    }
  }

  showPrivacyPolicyModal(): void {
    this.showPrivacyPolicy = true;
  }

  showTermsModal(): void {
    this.showTerms = true;
  }

  // Add the missing openTerms method (alias for showTermsModal)
  openTerms(): void {
    this.showTermsModal();
  }

  // Add the missing openPrivacyPolicy method (alias for showPrivacyPolicyModal)  
  openPrivacyPolicy(): void {
    this.showPrivacyPolicyModal();
  }

  closePrivacyPolicy(): void {
    this.showPrivacyPolicy = false;
  }

  closeTerms(): void {
    this.showTerms = false;
  }

  // Missing onKeyDown method for accessibility
  onKeyDown(event: KeyboardEvent): void {
    // Handle Escape key to close modals
    if (event.key === 'Escape') {
      if (this.showPrivacyPolicy) {
        this.closePrivacyPolicy();
      }
      if (this.showTerms) {
        this.closeTerms();
      }
    }
    
    // Handle Enter key for buttons/links
    if (event.key === 'Enter' || event.key === ' ') {
      const target = event.target as HTMLElement;
      
      if (target.classList.contains('close-btn')) {
        event.preventDefault();
        if (this.showPrivacyPolicy) {
          this.closePrivacyPolicy();
        }
        if (this.showTerms) {
          this.closeTerms();
        }
      }
      
      if (target.classList.contains('bottom-link')) {
        event.preventDefault();
        target.click();
      }
    }
  }

  // Handle modal backdrop clicks
  onModalBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('policy-modal')) {
      this.closePrivacyPolicy();
      this.closeTerms();
    }
  }

  privacyPolicyContent = `
**Thank you for visiting our website Aadinath Enterprise**, we take your privacy and security very seriously. This policy outlines how we collect, use, and protect the personal information you provide to us.

When you visit our website, we may collect personal information that you voluntarily provide, such as your name, email address, phone number, and company details. We may also collect non-personal information such as your IP address, browser type, and operating system for analytics purposes.

We use the information we collect to provide you with our services, respond to your inquiries, improve our website, and send you relevant updates and offers. We do not sell or share your personal information with third parties for marketing purposes.

We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, so we cannot guarantee absolute security.

We use cookies to enhance your browsing experience and analyze website traffic. You can choose to disable cookies in your browser settings, but this may affect your ability to access certain features of our website.

Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites. We recommend reading the privacy policies of any third-party sites you visit.

Our website is not intended for children under the age of 13. We do not knowingly collect personal information from children. If you believe that we have inadvertently collected information from a child, please get in touch with us to have it removed.

We reserve the right to update our privacy policy at any time. We will notify you of any changes by posting the revised policy on our website.

If you have any questions or concerns about our privacy policy, please get in touch with us **Aadinath Enterprise**.`;

  termsContent = `Welcome to **Aadinath Enterprise**. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please read these terms carefully before using our website.

Aadinath Enterprise will not be liable for any indirect, incidental, or consequential damages arising from your use of website or products.

We reserve the right to update or modify these terms and conditions at any time. Your continued use of the website after changes are made constitutes acceptance of the new terms.`;
}
